import { useMutation } from '@tanstack/react-query';
import { FeaturesApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useFeaturesControllerRestoreFeatureMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['featuresControllerRestoreFeature', accessControlScope],
        mutationFn: async (args) => {
            const api = new FeaturesApi(accessControlConfig);
            return api.featuresControllerRestoreFeature(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useFeaturesControllerRestoreFeatureMutation.js.map